/* Deklarativ bekräftelsemodal (A9b). Samma utseende och beteende som ConfirmDialog
   men styrd med open/onConfirm/onCancel från komponentens state — för de ställen
   som i dag har en egen lokal ConfirmModal-kopia. Nya flöden ska hellre använda
   kpConfirm() (Promise-API) från ./dialogApi.

     const [pending, setPending] = useState(null);
     <KpConfirmModal open={!!pending} title="Ta bort bilden?" message="Bilden tas bort."
       variant="danger" onConfirm={async () => { await remove(pending); setPending(null); }}
       onCancel={() => setPending(null)} />

   onConfirm får vara async: modalen går i busy-läge (knappar + Esc spärrade,
   "Ta bort…") tills löftet är klart, och stängs INTE av sig själv — anropande kod
   stänger genom att sätta open=false. Kastar onConfirm ett fel lämnas modalen öppen
   så att anropande kod kan visa felet (t.ex. kpToast.error).
   closeOnConfirm: anropa onCancel automatiskt när onConfirm är klar (för ställen
   vars gamla lokala modal stängde sig själv). */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ConfirmDialog from './ConfirmDialog';

export default function KpConfirmModal({ open, busy: busyProp = false, closeOnConfirm = false, onConfirm, onCancel, ...rest }) {
  const [running, setRunning] = useState(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);
  useEffect(() => { if (!open) setRunning(false); }, [open]);

  const handleConfirm = useCallback(async () => {
    if (running) return;
    const r = onConfirm && onConfirm();
    if (r && typeof r.then === 'function') {
      setRunning(true);
      try { await r; } finally { if (mounted.current) setRunning(false); }
    }
    if (closeOnConfirm && mounted.current && onCancel) onCancel();
  }, [onConfirm, onCancel, closeOnConfirm, running]);

  return (
    <ConfirmDialog open={!!open} busy={busyProp || running} onConfirm={handleConfirm} onCancel={onCancel || (() => {})} {...rest} />
  );
}
